/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoomSummaryV3 } from './RoomSummaryV3';
import {
    RoomSummaryV3FromJSON,
    RoomSummaryV3FromJSONTyped,
    RoomSummaryV3ToJSON,
    RoomSummaryV3ToJSONTyped,
} from './RoomSummaryV3';
import type { RateResponseStatus } from './RateResponseStatus';
import {
    RateResponseStatusFromJSON,
    RateResponseStatusFromJSONTyped,
    RateResponseStatusToJSON,
    RateResponseStatusToJSONTyped,
} from './RateResponseStatus';
import type { RateSourceStatus } from './RateSourceStatus';
import {
    RateSourceStatusFromJSON,
    RateSourceStatusFromJSONTyped,
    RateSourceStatusToJSON,
    RateSourceStatusToJSONTyped,
} from './RateSourceStatus';
import type { RecommendationSummary } from './RecommendationSummary';
import {
    RecommendationSummaryFromJSON,
    RecommendationSummaryFromJSONTyped,
    RecommendationSummaryToJSON,
    RecommendationSummaryToJSONTyped,
} from './RecommendationSummary';
import type { TransferPartnerSummary } from './TransferPartnerSummary';
import {
    TransferPartnerSummaryFromJSON,
    TransferPartnerSummaryFromJSONTyped,
    TransferPartnerSummaryToJSON,
    TransferPartnerSummaryToJSONTyped,
} from './TransferPartnerSummary';
import type { RatesSummary } from './RatesSummary';
import {
    RatesSummaryFromJSON,
    RatesSummaryFromJSONTyped,
    RatesSummaryToJSON,
    RatesSummaryToJSONTyped,
} from './RatesSummary';

/**
 * Terminal `complete` event when every expected source has reported in.
 * Carries the canonical aggregated payload — same shape as the polling
 * endpoint's `AdditionalRateResponseV3` — built via
 * `additional_rates_v3.build_additional_rates_response`. Clients should
 * replace any progressive state with the values in this event.
 * 
 * @export
 * @interface HotelRateStreamComplete
 */
export interface HotelRateStreamComplete {
    /**
     * 
     * @type {string}
     * @memberof HotelRateStreamComplete
     */
    type: HotelRateStreamCompleteTypeEnum;
    /**
     * 
     * @type {RateResponseStatus}
     * @memberof HotelRateStreamComplete
     */
    status: RateResponseStatus;
    /**
     * 
     * @type {Array<RoomSummaryV3>}
     * @memberof HotelRateStreamComplete
     */
    additionalRates: Array<RoomSummaryV3>;
    /**
     * 
     * @type {Array<RateSourceStatus>}
     * @memberof HotelRateStreamComplete
     */
    rateSourceStatuses?: Array<RateSourceStatus>;
    /**
     * 
     * @type {RatesSummary}
     * @memberof HotelRateStreamComplete
     */
    ratesSummary?: RatesSummary;
    /**
     * 
     * @type {Array<TransferPartnerSummary>}
     * @memberof HotelRateStreamComplete
     */
    transferPartnerSummaries?: Array<TransferPartnerSummary>;
    /**
     * 
     * @type {RecommendationSummary}
     * @memberof HotelRateStreamComplete
     */
    recommendationSummary?: RecommendationSummary;
}


/**
 * @export
 */
export const HotelRateStreamCompleteTypeEnum = {
    Complete: 'complete'
} as const;
export type HotelRateStreamCompleteTypeEnum = typeof HotelRateStreamCompleteTypeEnum[keyof typeof HotelRateStreamCompleteTypeEnum];


/**
 * Check if a given object implements the HotelRateStreamComplete interface.
 */
export function instanceOfHotelRateStreamComplete(value: object): value is HotelRateStreamComplete {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('additionalRates' in value) || value['additionalRates'] === undefined) return false;
    return true;
}

export function HotelRateStreamCompleteFromJSON(json: any): HotelRateStreamComplete {
    return HotelRateStreamCompleteFromJSONTyped(json, false);
}

export function HotelRateStreamCompleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelRateStreamComplete {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'status': RateResponseStatusFromJSON(json['status']),
        'additionalRates': ((json['additional_rates'] as Array<any>).map(RoomSummaryV3FromJSON)),
        'rateSourceStatuses': json['rate_source_statuses'] == null ? undefined : ((json['rate_source_statuses'] as Array<any>).map(RateSourceStatusFromJSON)),
        'ratesSummary': json['rates_summary'] == null ? undefined : RatesSummaryFromJSON(json['rates_summary']),
        'transferPartnerSummaries': json['transfer_partner_summaries'] == null ? undefined : ((json['transfer_partner_summaries'] as Array<any>).map(TransferPartnerSummaryFromJSON)),
        'recommendationSummary': json['recommendation_summary'] == null ? undefined : RecommendationSummaryFromJSON(json['recommendation_summary']),
    };
}

export function HotelRateStreamCompleteToJSON(json: any): HotelRateStreamComplete {
    return HotelRateStreamCompleteToJSONTyped(json, false);
}

export function HotelRateStreamCompleteToJSONTyped(value?: HotelRateStreamComplete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'status': RateResponseStatusToJSON(value['status']),
        'additional_rates': ((value['additionalRates'] as Array<any>).map(RoomSummaryV3ToJSON)),
        'rate_source_statuses': value['rateSourceStatuses'] == null ? undefined : ((value['rateSourceStatuses'] as Array<any>).map(RateSourceStatusToJSON)),
        'rates_summary': RatesSummaryToJSON(value['ratesSummary']),
        'transfer_partner_summaries': value['transferPartnerSummaries'] == null ? undefined : ((value['transferPartnerSummaries'] as Array<any>).map(TransferPartnerSummaryToJSON)),
        'recommendation_summary': RecommendationSummaryToJSON(value['recommendationSummary']),
    };
}

